module.exports = __webpack_public_path__ + "img/cliff.be5030ca.webp";